import { gql } from '@apollo/client'
import { BaseBlock, BlockFragment } from '../blocks.types'

export const ReferFriendBlockFragment: BlockFragment = {
  name: 'referFriend',
  fragment: gql`
    fragment referFriend on ReferFriend {
      id
      blockName
      blockType
      referFriendHeading: heading
      referFriendButtonLabel: buttonLabel
      referFriendCopyLinkLabel: copyLinkLabel
      referFriendBackgroundColor: backgroundColor
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on ReferFriend {
      id
      blockName
      blockType
      referFriendHeading: heading
      referFriendButtonLabel: buttonLabel
      referFriendCopyLinkLabel: copyLinkLabel
      referFriendBackgroundColor: backgroundColor
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const ReferFriendBlockType = 'referFriend'

export interface ReferFriendBlock extends BaseBlock {
  blockType: typeof ReferFriendBlockType
  referFriendHeading: string
  referFriendButtonLabel: string
  referFriendCopyLinkLabel: string
  referFriendBackgroundColor?: string
}
